import { useTranslation } from "react-i18next";
import { Select, SelectContent, SelectGroup, SelectItem, SelectTrigger } from "../ui/select";
import { supportedLanguages } from "@/lib/i18n";

export default function LanguageSelector() {

    const { i18n } = useTranslation()
    return <Select

        value={i18n.language}
        onValueChange={(v) => {
            i18n.changeLanguage(v);
            try {
                localStorage.setItem('i18nextLng', v);
            } catch { }
        }}>
        <SelectTrigger className="w-16 border-none bg-transparent hover:bg-accent/50 focus:ring-0">
            {i18n.language.toUpperCase()}
        </SelectTrigger>
        <SelectContent>
            <SelectGroup>
                {supportedLanguages.map((lang) => (
                    <SelectItem key={lang} value={lang} className="cursor-pointer">
                        {lang.toUpperCase()}
                    </SelectItem>
                ))}
            </SelectGroup>
        </SelectContent>
    </Select>
}